module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/index/img_flow-bc56e4ef2bb0c33f978298d32d235478.png";